import React, { useState } from "react";
import { Button, Container, Image } from "react-bootstrap";
import { Document, Page } from "react-pdf/dist/esm/entry.webpack";

const FinalScreen = () => {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }
  return (
    <div>
      <Container className="ml-5 mr-5 mt-5 ">
        <div className="d-flex justify-content-center mb-4">
          <Button
            onClick={() =>
              window.open(
                "https://drive.google.com/u/0/uc?id=1Jp45IX1tdLQrgJGh_szRP7A1dhyi0Jo9&export=download"
              )
            }
            variant="outline-danger"
          >
            Click Here to Download PDF
          </Button>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            margin: "10px",
            marginBottom: "20px",
          }}
        >
          <h5>
            Page {pageNumber} of {numPages}
          </h5>
        </div>
        <div
          style={{ display: "flex", justifyContent: "center", margin: "20px" }}
        >
          <Button
            onClick={() => {
              if (pageNumber > 1) {
                setPageNumber(pageNumber - 1);
              }
            }}
            style={{ marginRight: "10px" }}
          >
            {"<- Previous"}
          </Button>
          <Button
            onClick={() => {
              if (pageNumber < numPages) {
                setPageNumber(pageNumber + 1);
              }
            }}
            style={{ marginLeft: "10px" }}
          >
            {"Next ->"}
          </Button>
        </div>

        <div style={{ display: "flex", justifyContent: "center" }}>
          <Document
            file="./final.pdf"
            onLoadSuccess={onDocumentLoadSuccess}
            loading="Please wait while pdf is loading"
          >
            <Page pageNumber={pageNumber} />
          </Document>
          <br></br>
        </div>
      </Container>
    </div>
  );
};

export default FinalScreen;
